import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { IMAGES } from "@/data/site";

export const About = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section
      id="about"
      ref={ref}
      className="relative z-10 bg-[#F4EBD9] py-24 lg:py-32"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-7 order-2 lg:order-1">
          <p className="text-xs tracking-[0.3em] uppercase font-medium text-[#E07A5F] mb-6">
            About Haven For Tails
          </p>
          <motion.blockquote
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="font-display text-3xl sm:text-4xl lg:text-[2.75rem] leading-tight text-[#2B2D42] italic"
          >
            “Rescue animals aren’t broken. They simply experienced more life than
            other animals. If they were human we’d call them wise.”
            <footer className="mt-4 text-base not-italic font-body text-[#4A4E69]">
              — Unknown
            </footer>
          </motion.blockquote>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.15 }}
            className="mt-8 text-lg text-[#4A4E69] leading-relaxed max-w-2xl"
          >
            Haven for Tails is a youth-led nonprofit organization dedicated to
            caring for all animals. Our mission is to protect, care for, and
            support animals to give them the second chance they deserve. Many
            healthy rescued pets have trauma-related behaviors that make them
            hard to adopt, even if they’re healthy. It starts today. By
            supporting animal shelters, donating, and spreading awareness,
            significant changes can be made.
          </motion.p>
        </div>

        <div className="lg:col-span-5 order-1 lg:order-2">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9 }}
            className="arch-frame relative aspect-[4/5] max-w-sm mx-auto shadow-[0_20px_60px_rgba(43,45,66,0.18)]"
          >
            <motion.img
              style={{ y }}
              src={IMAGES.aboutCat}
              alt="A rescue cat framed by hands in a heart shape"
              className="h-[116%] w-full object-cover"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};
